// extracted by mini-css-extract-plugin
export default {"callSummary":"CallSummary_callSummary__9jLZI","description":"CallSummary_description__DfJJb"};